module.exports = __webpack_public_path__ + "static/equipment-tractor-2f9aaf02a95c1a4e38dc456d94b5f6a4.jpg";